// Imports
import ___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/noSourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_NO_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `#app-root {
  height: 100%;
}
.root-layout {
  height: 100%;
}
.nkl-layout.page-layout {
  position: relative;
  overflow: auto;
}
.nkl-layout-content.page-content {
  display: flex;
  flex-direction: column;
  flex-shrink: 0;
}
.nkl-layout-content.page-content .nkl-table-wrapper {
  margin: 0 24px 24px 24px;
}
.nkl-layout-content.page-content .nkl-table-export-btn-wrapper {
  margin: 0 24px 24px 24px;
  text-align: right;
}
.nkl-layout-header.page-header {
  background: transparent;
  padding: 0 24px;
  display: flex;
  align-items: center;
  height: 80px;
}
.nkl-layout-header.page-header > .nkl-row {
  width: 100%;
}
.nkl-layout-content.page-content {
  flex-shrink: 0;
}
.nkl-layout-content.page-content .nkl-table-wrapper {
  margin: 0 24px 24px 24px;
}
.nkl-layout-content.app-content {
  flex-shrink: 0;
}
.nkl-breadcrumb-link > a > .anticon + span {
  margin-left: 4px;
}
.nkl-message {
  margin-top: 64px !important;
}
.section {
  background: #fff;
}
.alert-section {
  width: calc(100% - 48px);
  margin: 0 24px 24px 24px;
}
@media (min-width: 0px) {
  .section.left {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.right {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
  .section.middle {
    margin: 0 24px 24px 24px;
    width: calc(100% - 48px);
  }
}
@media (min-width: 992px) {
  .section.left {
    margin-right: 12px;
    width: calc(100% - 36px);
  }
  .section.right {
    margin-left: 12px;
    width: calc(100% - 36px);
  }
  .section.middle {
    margin-left: 12px;
    width: calc(100% - 24px);
  }
}
.section-header {
  display: flex;
  align-items: center;
  font-size: 18px;
  height: 32px;
  line-height: 32px;
  margin-bottom: 24px;
}
.app-root {
  min-height: 100vh;
}
/* stylelint-disable at-rule-empty-line-before,at-rule-name-space-after,at-rule-no-unknown */
/* stylelint-disable no-duplicate-selectors */
/* stylelint-disable */
/* stylelint-disable declaration-bang-space-before,no-duplicate-selectors,string-no-newline */
`, ""]);
// Exports
export default ___CSS_LOADER_EXPORT___;
